module.exports = __webpack_public_path__ + "static/img/Ben-Murdoch-Masila.2a9ae84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Murdoch-Masila.jpg
// module id = NSY/
// module chunks = 0